/**
 * Marpiella Atelier - Dynamic Theme Scripts
 * Handles transparent headers, mobile drawers, and smooth accordion controls.
 */

document.addEventListener('DOMContentLoaded', () => {
  initHeaderScroll();
  initMobileMenu();
  initAccordions();
  initGalleryCarousel();
  initBackToTop();
  initProductRecommendations();
});

/**
 * Handles the scroll-triggered transparent header on Lingerie pages.
 */
function initHeaderScroll() {
  const header = document.getElementById('site-header');
  if (!header) return;

  const isInitiallyTransparent = header.classList.contains('header-transparent');
  if (!isInitiallyTransparent) return;

  const handleScroll = () => {
    if (window.scrollY > 20) {
      header.classList.remove('header-transparent');
    } else {
      header.classList.add('header-transparent');
    }
  };

  window.addEventListener('scroll', handleScroll);
  // Run once in case they reload scrolled down
  handleScroll();
}

/**
 * Handles the elegant mobile overlay hamburger menu.
 */
function initMobileMenu() {
  const btn = document.getElementById('mobile-menu-btn');
  const drawer = document.getElementById('mobile-menu-drawer');
  if (!btn || !drawer) return;

  const burgerIcon = btn.querySelector('.icon-hamburger');
  const closeIcon = btn.querySelector('.icon-close');

  btn.addEventListener('click', () => {
    const isActive = drawer.classList.contains('is-active');
    
    if (isActive) {
      drawer.classList.remove('is-active');
      setTimeout(() => drawer.style.display = 'none', 300);
      if (burgerIcon) burgerIcon.style.display = 'block';
      if (closeIcon) closeIcon.style.display = 'none';
      document.body.style.overflow = '';
    } else {
      drawer.style.display = 'block';
      // Reflow for transition
      drawer.offsetHeight;
      drawer.classList.add('is-active');
      if (burgerIcon) burgerIcon.style.display = 'none';
      if (closeIcon) closeIcon.style.display = 'block';
      document.body.style.overflow = 'hidden';
    }
  });
}

/**
 * Handles dynamic product details accordions.
 */
function initAccordions() {
  const headers = document.querySelectorAll('.pdp-accordion-btn');
  headers.forEach(btn => {
    btn.addEventListener('click', () => {
      const content = btn.nextElementSibling;
      const icon = btn.querySelector('.accordion-icon');
      
      if (content && content.classList.contains('pdp-accordion-content')) {
        const isCollapsed = content.style.display === 'none';
        content.style.display = isCollapsed ? 'block' : 'none';
        if (icon) {
          icon.style.transform = isCollapsed ? 'rotate(180deg)' : 'rotate(0deg)';
        }
      }
    });
  });
}

/**
 * Synchronizes PDP product thumb click scroll targets.
 * Handled dynamically based on visible elements for color filtering.
 */
function initGalleryCarousel() {
  const carousel = document.querySelector('.pdp-gallery-carousel');
  const thumbs = document.querySelectorAll('.pdp-gallery-thumb');
  const thumbContainer = document.querySelector('.pdp-gallery-thumbnails');
  const prevBtn = document.querySelector('.pdp-thumb-arrow--prev');
  const nextBtn = document.querySelector('.pdp-thumb-arrow--next');
  if (!carousel || thumbs.length === 0) return;

  const carouselPrev = document.getElementById('carousel-prev');
  const carouselNext = document.getElementById('carousel-next');

  const getVisibleSlides = () => {
    const slides = carousel.querySelectorAll('.pdp-carousel-slide');
    return Array.from(slides).filter(slide => slide.style.display !== 'none');
  };

  const getActiveSlideIndex = (visibleSlides) => {
    const scrollPos = carousel.scrollLeft;
    const slideWidth = carousel.clientWidth;
    if (slideWidth <= 0) return 0;
    return Math.round(scrollPos / slideWidth);
  };

  const updateArrowState = () => {
    if (!thumbContainer || !prevBtn || !nextBtn) return;
    const maxScroll = thumbContainer.scrollWidth - thumbContainer.clientWidth;
    if (maxScroll <= 5) {
      prevBtn.style.display = 'none';
      nextBtn.style.display = 'none';
    } else {
      prevBtn.style.display = 'flex';
      nextBtn.style.display = 'flex';
      prevBtn.disabled = thumbContainer.scrollLeft <= 5;
      nextBtn.disabled = thumbContainer.scrollLeft >= maxScroll - 5;
    }
  };

  if (carouselPrev && carouselNext) {
    carouselPrev.addEventListener('click', () => {
      const visibleSlides = getVisibleSlides();
      if (visibleSlides.length <= 1) return;
      const activeIdx = getActiveSlideIndex(visibleSlides);
      const prevIdx = (activeIdx - 1 + visibleSlides.length) % visibleSlides.length;
      
      window.isProgrammaticScroll = true;
      carousel.style.scrollSnapType = 'none';
      carousel.scrollTo({
        left: prevIdx * carousel.clientWidth,
        behavior: 'smooth'
      });
      setTimeout(() => {
        carousel.style.scrollSnapType = 'x mandatory';
        window.isProgrammaticScroll = false;
      }, 400);

      const mediaId = visibleSlides[prevIdx].getAttribute('data-media-id');
      const thumb = Array.from(thumbs).find(t => t.getAttribute('data-media-id') === mediaId && t.style.display !== 'none');
      if (thumb && thumbContainer) {
        thumbs.forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
        const containerWidth = thumbContainer.clientWidth;
        const thumbOffset = thumb.offsetLeft;
        const thumbWidth = thumb.clientWidth;
        thumbContainer.scrollTo({
          left: thumbOffset - (containerWidth / 2) + (thumbWidth / 2),
          behavior: 'smooth'
        });
      }
    });

    carouselNext.addEventListener('click', () => {
      const visibleSlides = getVisibleSlides();
      if (visibleSlides.length <= 1) return;
      const activeIdx = getActiveSlideIndex(visibleSlides);
      const nextIdx = (activeIdx + 1) % visibleSlides.length;

      window.isProgrammaticScroll = true;
      carousel.style.scrollSnapType = 'none';
      carousel.scrollTo({
        left: nextIdx * carousel.clientWidth,
        behavior: 'smooth'
      });
      setTimeout(() => {
        carousel.style.scrollSnapType = 'x mandatory';
        window.isProgrammaticScroll = false;
      }, 400);

      const mediaId = visibleSlides[nextIdx].getAttribute('data-media-id');
      const thumb = Array.from(thumbs).find(t => t.getAttribute('data-media-id') === mediaId && t.style.display !== 'none');
      if (thumb && thumbContainer) {
        thumbs.forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
        const containerWidth = thumbContainer.clientWidth;
        const thumbOffset = thumb.offsetLeft;
        const thumbWidth = thumb.clientWidth;
        thumbContainer.scrollTo({
          left: thumbOffset - (containerWidth / 2) + (thumbWidth / 2),
          behavior: 'smooth'
        });
      }
    });
  }

  // Thumbnail click → scroll main carousel
  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const visibleThumbs = Array.from(thumbs).filter(t => t.style.display !== 'none');
      
      visibleThumbs.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      
      const idx = visibleThumbs.indexOf(thumb);
      if (idx !== -1) {
        window.isProgrammaticScroll = true;
        carousel.style.scrollSnapType = 'none';
        carousel.scrollTo({
          left: idx * carousel.clientWidth,
          behavior: 'smooth'
        });
        setTimeout(() => {
          carousel.style.scrollSnapType = 'x mandatory';
          window.isProgrammaticScroll = false;
        }, 400);
      }
    });
  });

  // Highlight active thumb on main carousel scroll
  carousel.addEventListener('scroll', () => {
    if (window.isProgrammaticScroll) return;
    
    const scrollPos = carousel.scrollLeft;
    const activeIdx = Math.round(scrollPos / carousel.clientWidth);
    
    const visibleThumbs = Array.from(thumbs).filter(t => t.style.display !== 'none');
    visibleThumbs.forEach((thumb, idx) => {
      if (idx === activeIdx) {
        thumb.classList.add('active');
        if (thumbContainer) {
          const containerWidth = thumbContainer.clientWidth;
          const thumbOffset = thumb.offsetLeft;
          const thumbWidth = thumb.clientWidth;
          thumbContainer.scrollTo({
            left: thumbOffset - (containerWidth / 2) + (thumbWidth / 2),
            behavior: 'smooth'
          });
        }
      } else {
        thumb.classList.remove('active');
      }
    });
  });

  // Thumbnail arrow navigation
  if (prevBtn && nextBtn && thumbContainer) {
    prevBtn.addEventListener('click', () => {
      thumbContainer.scrollBy({ left: -thumbContainer.clientWidth, behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', () => {
      thumbContainer.scrollBy({ left: thumbContainer.clientWidth, behavior: 'smooth' });
    });

    thumbContainer.addEventListener('scroll', updateArrowState);

    // Initial state check (also run after color filter changes)
    setTimeout(updateArrowState, 200);

    // Expose for filterGallery to call after filtering
    window.updateThumbArrows = updateArrowState;
  }
}

/**
 * Handles back-to-top button visibility and smooth scroll behavior.
 */
function initBackToTop() {
  const btn = document.getElementById('backToTopButton');
  if (!btn) return;

  const handleScroll = () => {
    if (window.scrollY > 300) {
      btn.classList.add('is-visible');
    } else {
      btn.classList.remove('is-visible');
    }
  };

  window.addEventListener('scroll', handleScroll);
  // Initial check
  handleScroll();

  btn.addEventListener('click', () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  });
}

/**
 * Initializes Shopify native Product Recommendations.
 * Queries recommendations endpoint dynamically and injects the rendered HTML.
 */
function initProductRecommendations() {
  const recommendationsSection = document.querySelector('.product-recommendations');
  if (!recommendationsSection) return;

  const url = recommendationsSection.getAttribute('data-url');
  if (!url) return;

  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(recommendationsSection);

    fetch(url)
      .then(response => response.text())
      .then(htmlText => {
        const parser = new DOMParser();
        const htmlDoc = parser.parseFromString(htmlText, 'text/html');
        const recommendations = htmlDoc.querySelector('.product-recommendations');
        if (recommendations && recommendations.innerHTML.trim().length > 0) {
          recommendationsSection.innerHTML = recommendations.innerHTML;
        }
      })
      .catch(err => console.error('[Recommendations Error]', err));
  };

  const observer = new IntersectionObserver(handleIntersection, { rootMargin: '0px 0px 200px 0px' });
  observer.observe(recommendationsSection);
}
